import React, { FC } from 'react';
import { useQuery } from 'react-query';
import { GoalsApi } from 'api/goal';
import { GENERAL_API_STALE } from 'config/query-config';
import { ErrorContent } from '../error';
import { LoadingContent } from '../loading';
import { DataContent } from './_card-carousel';
import { EmptyContent } from './_card-empty';

export const Content: FC<{ projectId: number }> = ({ projectId }) => {
  const { data, isLoading, isError, refetch } = useQuery(
    ['project-overview-goals', projectId],
    () => GoalsApi.getGoals(projectId),
    {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: GENERAL_API_STALE,
    },
  );

  return (
    <>
      {isLoading ? (
        <LoadingContent />
      ) : isError ? (
        <ErrorContent onErrorRefresh={refetch} />
      ) : data && (data || []).length > 0 ? (
        <DataContent data={data} projectId={projectId} />
      ) : (
        <EmptyContent projectId={projectId} />
      )}
    </>
  );
};
